import React from "react";
import PropTypes from "prop-types";

const Login = props => (
  <div className="wrapper">
    <p>Sign in to manage your posts <span>&#128522;</span></p>
    <button className="github" onClick={() => props.authenticate('Github')}>Log in</button>
  </div>
);

Login.propTypes = {
  authenticate: PropTypes.func.isRequired
};

export default Login;